import SnackItem from "./SnackItem";

export default SnackItem;
